"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./GlobalHeader.css");
require("./GlobalHeader.mobile.css");
var icons = require("./../../../styles/att-icons.css");
var Label_1 = require("../../atoms/Label");
var LabelProps_1 = require("../../atoms/Label/LabelProps");
var GlobalHeader = /** @class */ (function (_super) {
    __extends(GlobalHeader, _super);
    function GlobalHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalHeader.prototype.render = function () {
        var cssClasses = [styles.globalHeader];
        return (React.createElement("div", { "data-test-id": this.props.testId, className: cssClasses.join(' ') },
            React.createElement("div", { className: styles.horizontalContainer },
                React.createElement("div", { className: styles.globeDesktop },
                    React.createElement("a", { href: this.props.options.hrefOption, title: "" },
                        React.createElement("i", { className: [icons.attIcon, icons.attIconAttGlobe, icons.attIconLg].join(' '), "aria-label": (this.props.options && this.props.options.accessibility) || 'AT&T home', role: "img" }))),
                this.props.data && this.props.data.header &&
                    React.createElement("div", null,
                        React.createElement(Label_1.default, { data: { isDecodingRequired: false, text: this.props.data.header }, options: { className: styles.headerLabel, size: LabelProps_1.LabelSizes.LARGE } })),
                React.createElement("div", { className: styles.menu }, "\u00A0"),
                React.createElement("div", { className: styles.search }, "\u00A0"),
                React.createElement("div", { className: styles.globeMobile },
                    React.createElement("a", { href: "https://www.att.com", title: "" },
                        React.createElement("i", { className: [icons.attIcon, icons.attIconAttGlobe, icons.attIconLg].join(' '), "aria-label": (this.props.options && this.props.options.accessibility) || 'AT&T home', role: "img" }))),
                React.createElement("div", { className: styles.cart }, "\u00A0"),
                React.createElement("div", { className: styles.signIn }, "\u00A0"))));
    };
    return GlobalHeader;
}(React.Component));
exports.default = GlobalHeader;
//# sourceMappingURL=GlobalHeader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/GlobalHeader/GlobalHeader.js
// module id = 1388
// module chunks = 8